import React from 'react';
import Icon from '@/components/ui/AppIcon';

const stats = [
  { id: 'stat-stars', label: 'Yıldız', value: '340', icon: 'StarIcon', color: 'text-gold' },
  { id: 'stat-visits', label: 'Ziyaret', value: '47', icon: 'MapPinIcon', color: 'text-primary' },
  { id: 'stat-since', label: 'Üye', value: '2022', icon: 'CalendarIcon', color: 'text-muted-foreground' },
];

export default function ProfileStats() {
  return (
    <div className="bg-card border-b border-border">
      <div className="flex items-stretch divide-x divide-border">
        {stats.map((stat) => (
          <div key={stat.id} className="flex-1 flex flex-col items-center py-4 gap-1">
            <Icon name={stat.icon as any} size={18} variant="solid" className={stat.color} />
            <span className="text-foreground font-black text-xl font-tabular">{stat.value}</span>
            <span className="text-muted-foreground text-xs font-medium">{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}